/**
 * Lê o corpo como JSON; corpo vazio ou não-JSON não rebentam o fluxo (ex.: 503 sem body no gate).
 */
export async function readResponseJson(response) {
  const text = await response.text();
  if (!text || !text.trim()) {
    return {};
  }
  try {
    return JSON.parse(text);
  } catch {
    return { error: 'Resposta inválida do servidor.' };
  }
}

export function attachHttpFallbackError(data, response) {
  if (response.ok || (data && data.error)) {
    return data;
  }
  const fallback =
    response.status === 503
      ? 'Serviço a iniciar. Espera alguns segundos e tenta de novo.'
      : 'Erro de comunicação com o servidor.';
  return { ...data, error: data.error || fallback };
}
